export * from "./good-deal-brand.component";
